<!--
  余额充值
  lovi 2020-1-9
-->
<template>
  <div class="w100">
    <van-nav-bar
      class="gradient"
      :title="$t('wallet.balanceRecharge')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    >
      <span slot="right" @click="_linkFun('/record?flag=1')">
        {{ $t("common.rechargeRecord") }}
      </span>
    </van-nav-bar>

    <div class="scroll-wrapper">
      <div class="bg"></div>
      <scroll ref="scroll">
        <div class="money-wrap">
          <dl v-if="userInfo.money_usable">
            <dt>
              <span>{{ $t("common.balance") }}</span>
            </dt>
            <dd>
              <h3>{{ userInfo.money_usable }}</h3>
              <span>PHP</span>
            </dd>
          </dl>
        </div>

        <div class="column select-amount">
          <div class="title">{{ $t("wallet.walletRechargeSelectAmount") }}</div>
          <div class="money-list">
            <ul>
              <li
                v-for="(item, index) in moneyList"
                :key="index"
                :class="
                  checkedMoney == null && item.is_default == 1
                    ? 'active'
                    : checkedMoney == item.piso_value
                    ? 'active'
                    : ''
                "
                @click="changeMoney(item.piso_value)"
              >
                <h3>{{ item.piso_value }}P</h3>
                <p v-if="curPay.exchange_rate">
                  {{ $t("common.price") }}
                  {{
                    curPay.exchange_rate
                      ? _PHPtoRMB(item.piso_value, curPay.exchange_rate)
                      : ""
                  }}
                  {{ $t("common.CNY") }}
                </p>
              </li>
            </ul>
          </div>
          <van-field
            class="van-field-input"
            v-model="checkedMoney"
            type="number"
            :formatter="_formatter"
            :placeholder="$t('common.enterAmount')"
            clearable
          >
            <span slot="right-icon">P</span>
          </van-field>
        </div>

        <!-- 选择支付方式 -->
        <pay-list @getCurPay="getCurPay" :type="1"></pay-list>

        <div class="button-wrap">
          <van-button block type="primary" @click="nextStepFun">
            {{ $t("common.rechargeNow") }}
          </van-button>
        </div>
      </scroll>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PayList from "@/components/payList";
export default {
  name: "recharge",
  meta: {
    keepAlive: true
  },
  components: {
    PayList
  },
  data() {
    return {
      rechargeInfo: {}, //充值信息
      moneyList: [], //快捷金额
      checkedMoney: null, //金额
      curPay: [], //当前支付数据
      offlineData: {}
    };
  },
  created() {
    this._getRechargeInfo();
    this.$store.dispatch("GET_USER_INFO");
  },
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    changeMoney(money) {
      this.checkedMoney = money;
    },
    _getRechargeInfo() {
      // 获取快捷金额
      let vm = this;
      vm.$post(
        "/app/accountrecharge/rechargeBalanceMainInfo",
        {},
        { loading: true }
      ).then(res => {
        console.log("rechargeBalanceMainInfo", res);
        vm.rechargeInfo = res;
        vm.moneyList = res.recharge_money_list;
        for (var i = 0; i < vm.moneyList.length; i++) {
          if (vm.moneyList[i].is_default == 1) {
            vm.checkedMoney = vm.moneyList[i].piso_value;
          }
        }
      });
    },
    getCurPay(data) {
      // 获取当前支付信息
      this.curPay = data;
    },
    nextStepFun() {
      // 下一步
      let vm = this;
      vm.checkedMoney = Number(vm.checkedMoney).toFixed(2);
      if (vm.checkedMoney == 0) {
        vm.$toast(vm.$t("common.enterAmount"));
        return;
      }
      let params = {};
      params.payment_id = vm.curPay.payment_id; // 支付方式，5.微信扫码支付、7.线下现金、8.线下银行卡
      params.money = vm.checkedMoney;
      // params.detail = "余额充值";
      if (vm.curPay.type == 5||vm.curPay.type == 1||vm.curPay.type == 2||vm.curPay.type == 10) {
        // 5.微信扫码支付
        vm.payment(params);
      }
      if (vm.curPay.type == 7) {
        // 7.线下现金
        vm.offLine(params);
      }
      if (vm.curPay.type == 8) {
        // 8.线下银行卡
        let obj = {};
        obj.bank_id = "";
        obj.bank_name = "";
        obj.bank_username = "";
        obj.card_number = "";
        obj.country = "";
        obj.exchange_rate = "";
        params.bank = obj;
        params.money = vm.checkedMoney + "P";
        params.type = vm.curPay.type;
        params.title = vm.curPay.name;
        params.selectBank = true;
        console.log("params", params);
        vm.$router.push({
          path: "/rechargeOffline",
          name: "rechargeOffline",
          params: params
        });
      }
    },
    payment(data) {
      // 微信扫码支付
      let vm = this;
      vm.$post("/app/pay/payment", data, { loading: true }).then(res => {
        console.log("payment", res);
        let routeData = res;

        console.log("vm", vm.curPay.type);
        if (vm.curPay.type == 5) {
          // 微信扫码支付
          routeData.money = vm.checkedMoney + "P";
          // 线上支付
          vm.$router.push({
            path: "/payCode",
            name: "payCode",
            query: { flag: 1, payType: vm.curPay.type },
            params: routeData
          });
        }

        if (vm.curPay.type == 2||vm.curPay.type == 10) {
          //支付宝app付
          /* eslint-disable */

          if(vm.curPay.type == 10)
          {
            debugger
            window.location.href=res.return_charge.content;
            routeData.button = true;
            vm.$router.push({
              path: "/detail",
              name: "detail",
              query: {
                flag: 1,
                order_id: res.order_id
              },
              params: routeData
            });

          }
          else {
            jsBridge.aliPay({
              orderString: res.return_charge.query
            }, function(succ, text) {
              if (succ) {
                alert("支付成功");
                routeData.button = true;
                vm.$router.push({
                  path: "/detail",
                  name: "detail",
                  query: {
                    flag: 1,
                    order_id: res.order_id
                  },
                  params: routeData
                });
              } else {
                alert("支付失败或取消了支付");
              }
            });
          }
        }
        if (vm.curPay.type == 1) {
          //微信app付
          /* eslint-disable */
          if (vm.enter == "wechat") {
            window.location.href=res.return_charge.content;
            routeData.button = true;
            vm.$router.push({
              path: "/detail",
              name: "detail",
              query: {
                flag: 1,
                order_id: res.order_id
              },
              params: routeData
            });
          }
          else {
            jsBridge.wxPay({
              appid: res.return_charge.appid,
              partnerid: res.return_charge.partnerid,
              prepayid: res.return_charge.prepayid,
              package: res.return_charge.package,
              noncestr: res.return_charge.noncestr,
              timestamp: res.return_charge.timestamp,
              sign: res.return_charge.sign
            }, function(succ, text) {
              if (succ) {
                routeData.button = true;
                vm.$router.push({
                  path: "/detail",
                  name: "detail",
                  query: {
                    flag: 1,
                    order_id: res.order_id
                  },
                  params: routeData
                });
              } else {

              }
            });
          }
        }

      });
    },
    offLine(data) {
      // 线下现金
      let vm = this;
      vm.$post("/app/pay/cash_pay", data, { loading: true }).then(res => {
        console.log("cash_pay", res);
        let routeData = res;
        routeData.money = vm.checkedMoney + "P";
        routeData.type = vm.curPay.type;
        routeData.title = vm.curPay.name;
        vm.$router.push({
          path: "/rechargeOffline",
          name: "rechargeOffline",
          params: routeData
        });
      });
    },
    _getDetails(id) {
      // 详情
      this.stepIndex = 2;
      this.detailsId = Number(id);
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.scroll-wrapper {
  background: #f4f4f4;
  .bg {
    height: 50px;
    background: linear-gradient(90deg, #2043ac, #130f73);
  }
}

.money-wrap {
  margin: 0 15px;
  height: 130px;
  padding: 15px;
  color: #fff;
  line-height: 1;
  background: url("~@/assets/images/wallet/card_bg2@2x.png") no-repeat;
  background-size: cover;
  border-radius: 8px;
  dl {
    dt,
    dd {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    dt {
      height: 20px;
      font-size: 14px;
      /deep/.van-icon {
        margin-left: 10px;
        font-size: 16px;
      }
    }
    dd {
      margin-top: 10px;
      height: 30px;
      font-size: 16px;
      h3 {
        font-size: 32px;
        font-weight: 500;
        color: #fff;
        text-shadow: 0px 1px 2px rgba(93, 58, 0, 0.31);
      }
      span {
        margin-left: 10px;
        font-size: 14px;
      }
    }
  }
}

.column {
  .title {
    h3 {
      font-size: 16px;
    }
  }

  &.select-amount {
    padding: 15px;
    .title {
      padding: 0;
    }
    .money-list {
      ul {
        display: flex;
        flex-wrap: wrap;
        margin: 5px 0 5px -8px;
        width: calc(100% + 8px);
        li {
          display: flex;
          justify-content: center;
          flex-flow: column;
          margin: 5px 0 5px 8px;
          width: calc(33.3333% - 8px);
          text-align: center;
          height: 54px;
          line-height: 1;
          color: #9b9b9b;
          background: #fff;
          border: 1.1px solid #ccc;
          border-radius: 5px;
          &.active {
            color: #fff;
            background: linear-gradient(
              90deg,
              rgba(32, 67, 172, 1) 0%,
              rgba(19, 15, 115, 1) 100%
            );
            border-color: rgba(32, 67, 172, 1);
          }
          h3 {
            font-weight: 400;
          }
          p {
            margin-top: 4px;
            font-size: 10px;
            // transform: scale(0.9)
          }
        }
      }
    }
  }
}
</style>
